export default "__VITE_ASSET__Bs2K19c2__"